import { embedSources, getVimeoId, getYoutubeId } from "@assets/ts/videoEmbed";
import { VideoEmbed } from "@assets/tsx/videoEmbed";
import React, { useEffect, useState } from "react";
import placeholder from '@assets/img/default.png';
import { useBreakpoint } from "@assets/tsx/useBreakpoint";
import Swipable from '@assets/tsx/swipeable/swipeable';
import { useI18n } from "@wordpress/react-i18n";
import { Modal } from "@assets/tsx/modal";
import OutsideAlerter from "@assets/tsx/outsideClicker";
import { FocusTrap } from "@assets/tsx/focusTrap";
export default function Gallery(props) {
    var _a;
    if ((props === null || props === void 0 ? void 0 : props.source) === 'post' && typeof window !== 'undefined') {
        const { elementor } = window;
        const post_gallery = (elementor === null || elementor === void 0 ? void 0 : elementor.getContainer) ? elementor.getContainer('document').getSetting('featured_gallery') : (_a = props === null || props === void 0 ? void 0 : props.prefetch) === null || _a === void 0 ? void 0 : _a.featured_gallery;
        return React.createElement(GalleryWidget, Object.assign({}, post_gallery));
    }
    return React.createElement(GalleryWidget, Object.assign({}, props));
}
export function GalleryWidget({ gallery, format, height, prefetch }) {
    const [current, setCurrent] = useState(0);
    const [list, setList] = useState(null);
    const [listScroll, setListScroll] = useState(0);
    const [listScrollAtStart, setListScrollAtStart] = useState(true);
    const [listScrollAtEnd, setListScrollAtEnd] = useState(true);
    const [listArrows, setListArrows] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const breakpoint = useBreakpoint();
    const { __ } = useI18n();
    let customFormat = {};
    if (format === 'custom' && (height === null || height === void 0 ? void 0 : height.size)) {
        if (height.unit === 'px') {
            customFormat = { style: { height: `${height.size}px` } };
        }
        else if (height.unit === '%') {
            customFormat = { style: { paddingBottom: `${height.size}%` } };
        }
    }
    function go(dir) {
        let next = current + dir;
        if (next > gallery.length - 1) {
            next = 0;
        }
        if (next < 0) {
            next = gallery.length - 1;
        }
        setCurrent(next);
    }
    function scroll(dir) {
        if (!list)
            return;
        let ammount = listScroll + 200 * dir;
        const { offsetWidth, scrollWidth } = list;
        const maxScroll = scrollWidth - offsetWidth;
        if (ammount > maxScroll)
            ammount = maxScroll;
        if (ammount < 0)
            ammount = 0;
        setListScroll(ammount);
    }
    // centruojam current list itema
    useEffect(() => {
        if (!listArrows)
            return;
        const listContent = list.querySelector('.ltg-gallery-list-content');
        const selected = listContent.children[current];
        const { left, width } = selected.getBoundingClientRect();
        const { left: listLeft, width: listWidth } = list.getBoundingClientRect();
        const listCenter = listLeft + listWidth / 2;
        const selectedCenter = left + list.scrollLeft + width / 2;
        const maxScroll = list.scrollWidth - list.offsetWidth;
        let ammount = selectedCenter - listCenter;
        if (ammount > maxScroll)
            ammount = maxScroll;
        if (ammount < 0)
            ammount = 0;
        setListScroll(ammount);
    }, [current]);
    // rodom/slepiam gradientus
    useEffect(() => {
        if (!list)
            return;
        list.scrollLeft = listScroll;
        const { offsetWidth, scrollWidth } = list;
        const atStart = listScroll === 0;
        const atEnd = listScroll === scrollWidth - offsetWidth;
        setListScrollAtStart(atStart);
        setListScrollAtEnd(atEnd);
    }, [listScroll, list, gallery]);
    // ar reikia rodykliu
    useEffect(() => {
        if (!list)
            return;
        const { offsetWidth, scrollWidth } = list;
        const noScroll = offsetWidth === scrollWidth;
        setListArrows(!noScroll);
    }, [list, gallery, breakpoint]);
    if (!gallery || (gallery === null || gallery === void 0 ? void 0 : gallery.length) === 0)
        return React.createElement(React.Fragment, null,
            React.createElement("h1", null, "Sukurkite galerij\u0105"));
    const { image_fit, crop } = gallery[current] || {};
    const Image = () => React.createElement(GalleryImage, Object.assign({}, { format, customFormat, gallery, current, placeholder: prefetch === null || prefetch === void 0 ? void 0 : prefetch.placeholder, setModalOpen }, { transform: image_fit === 'yes' ? crop === null || crop === void 0 ? void 0 : crop.computed : null }));
    return (React.createElement("div", { className: "ltg-gallery" },
        React.createElement("div", { className: "ltg-gallery-current-wrap" },
            breakpoint !== 'mobile' && (React.createElement(React.Fragment, null,
                React.createElement(Arrow, { command: go, dir: -1 }),
                React.createElement(Arrow, { command: go, dir: 1 }))),
            breakpoint === 'mobile' ? (React.createElement(Swipable, { onSwipeLeft: () => { go(-1); }, onSwipeRight: () => { go(1); } },
                React.createElement(Image, null))) : (React.createElement(Image, null))),
        React.createElement("div", { className: `ltg-gallery-list-wrap${listScrollAtStart ? ' --at-start' : ''}${listScrollAtEnd ? '  --at-end' : ''}` },
            listArrows && (React.createElement(React.Fragment, null,
                React.createElement(Arrow, { command: scroll, dir: -1 }),
                React.createElement(Arrow, { command: scroll, dir: 1 }))),
            React.createElement("div", { className: `ltg-gallery-list`, ref: setList },
                React.createElement("div", { className: `ltg-gallery-list-height ltg-gallery-list-height--${format}` }, Object.keys(customFormat).length > 0 && ((() => {
                    var _a, _b;
                    let customItemFormat = { style: Object.assign({}, customFormat.style) };
                    if (!!((_a = customFormat === null || customFormat === void 0 ? void 0 : customFormat.style) === null || _a === void 0 ? void 0 : _a.height) && (list === null || list === void 0 ? void 0 : list.offsetWidth)) {
                        const listWidth = list === null || list === void 0 ? void 0 : list.offsetWidth;
                        const itemHeight = parseInt((_b = customFormat === null || customFormat === void 0 ? void 0 : customFormat.style) === null || _b === void 0 ? void 0 : _b.height);
                        const proportion = 200 / listWidth;
                        customItemFormat.style.height = `${Math.round(itemHeight * proportion)}px`;
                    }
                    return React.createElement("div", Object.assign({}, customItemFormat));
                })())),
                React.createElement("div", { className: "ltg-gallery-list-content" }, gallery.map((item, index) => {
                    var _a;
                    const { _id, alt, image, image_fit, crop, video_source, hosted_url } = item;
                    const { url, alt: imgAlt, size, sizes } = image || {};
                    const crop_style = image_fit === 'yes' ? { style: { transform: (crop === null || crop === void 0 ? void 0 : crop.computed) || 'translateX(0) translateY(0) scale(1)' } } : {};
                    let imageUrl = typeof sizes === 'object' ? (_a = sizes['medium']) === null || _a === void 0 ? void 0 : _a.url : url;
                    if (video_source === 'youtube') {
                        const videoId = getYoutubeId(hosted_url === null || hosted_url === void 0 ? void 0 : hosted_url.url);
                        if (videoId) {
                            imageUrl = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
                        }
                    }
                    if (video_source === 'vimeo') {
                        const videoId = getVimeoId(hosted_url === null || hosted_url === void 0 ? void 0 : hosted_url.url);
                        if (videoId) {
                            imageUrl = `${placeholder}?for=${videoId}`;
                            fetch(`https://vimeo.com/api/v2/video/${videoId}.json`)
                                .then(res => res.json())
                                .then((data) => {
                                const [video_data] = data;
                                const { title, thumbnail_medium } = video_data;
                                if (!list)
                                    return;
                                let thumbnail = list.querySelector(`img[src$="?for=${videoId}"]`);
                                if (thumbnail) {
                                    thumbnail.src = thumbnail_medium;
                                    thumbnail.alt = title;
                                }
                            });
                        }
                    }
                    return (React.createElement("div", { className: `ltg-gallery-list-item${image_fit === 'yes' ? ' --cropped' : ''}`, key: _id || (image === null || image === void 0 ? void 0 : image.id) },
                        React.createElement("img", Object.assign({ className: "ltg-gallery-list-item-img", src: imageUrl, alt: alt || imgAlt || `${__("Galerijos nuotrauka", "ltg-widgets")} ${index + 1}` }, crop_style, { tabIndex: 0, onClick: () => {
                                setCurrent(index);
                            }, onKeyDown: (ev) => {
                                if (!pressed(ev))
                                    return;
                                ev.preventDefault();
                                ev.stopPropagation();
                                setCurrent(index);
                            } })),
                        (item === null || item === void 0 ? void 0 : item.is_video) === 'yes' && (React.createElement("div", { className: "ltg-gallery-indicator" },
                            React.createElement("span", { className: "btn btn-white btn-circle text-primary" },
                                React.createElement("i", { className: "fas fa-video" }))))));
                })))),
        React.createElement(GalleryModal, { open: modalOpen, format: format, height: height, setOpen: setModalOpen },
            React.createElement("div", { className: "ltg-gallery-current-wrap" },
                breakpoint !== 'mobile' && (React.createElement(React.Fragment, null,
                    React.createElement(Arrow, { command: go, dir: -1 }),
                    React.createElement(Arrow, { command: go, dir: 1 }))),
                breakpoint === 'mobile' ? (React.createElement(Swipable, { onSwipeLeft: () => { go(-1); }, onSwipeRight: () => { go(1); } },
                    React.createElement(Image, null))) : (React.createElement(Image, null))))));
}
export function GalleryImage({ format, customFormat, gallery, current, transform, placeholder, setModalOpen }) {
    var _a, _b;
    const item = gallery[current];
    let transformStr = transform;
    const fitPostStyle = (item === null || item === void 0 ? void 0 : item.image_fit) === "yes" ? { style: { transform: transformStr } } : {};
    return React.createElement("div", Object.assign({ className: `ltg-gallery-current ltg-gallery-current--${format}${(item === null || item === void 0 ? void 0 : item.is_video) === 'yes' ? ' --is-video' : ''}${embedSources.includes(item.video_source) ? ' --is-embed' : ''}` }, customFormat),
        React.createElement(CurrentItem, { item: item, fitPostStyle: fitPostStyle, cropped: (item === null || item === void 0 ? void 0 : item.image_fit) === "yes", video: (item === null || item === void 0 ? void 0 : item.is_video) === 'yes' ? (_a = item === null || item === void 0 ? void 0 : item.hosted_url) === null || _a === void 0 ? void 0 : _a.url : null, placeholder: placeholder }),
        React.createElement("button", { className: "ltg-gallery-indicator", onClick: () => { setModalOpen(prev => !prev); } },
            React.createElement("span", { className: "btn btn-white btn-circle text-primary" },
                React.createElement("i", { className: ((_b = gallery[current]) === null || _b === void 0 ? void 0 : _b.is_video) === 'yes' ? 'fas fa-video' : 'fas fa-camera' })),
            React.createElement("span", { className: "ltg-gallery-indicator-text" },
                current + 1,
                "/",
                gallery.length)));
}
function GalleryModal({ children, open, setOpen, format, height }) {
    // console.log({format,height});
    return React.createElement(Modal, { open: open, className: `ltg-gallery-modal` },
        React.createElement(FocusTrap, null,
            React.createElement("div", { className: "ltg-gallery-modal-header" },
                React.createElement("button", { className: "ltg-gallery-modal-close", "aria-label": "Close", onClick: () => { setOpen(false); } },
                    React.createElement("i", { className: "fas fa-times" }))),
            React.createElement("div", { className: `ltg-gallery-modal-content-wrap` },
                React.createElement("div", { className: `ltg-gallery-modal-content --${format}`, style: (format === 'custom' && height.unit === '%') ? {
                        aspectRatio: `100 / ${height.size}`
                    } : (format === 'custom' && height.unit === 'px') ? { width: '100vh' } : undefined },
                    React.createElement(OutsideAlerter, { callback: () => { setOpen(false); } }, children)))));
}
function CurrentItem({ item, fitPostStyle = {}, cropped, video, placeholder }) {
    var _a, _b, _c;
    const { __ } = useI18n();
    const src = typeof ((_a = item === null || item === void 0 ? void 0 : item.image) === null || _a === void 0 ? void 0 : _a.sizes) === 'object' ? item.image.sizes[item.image.size].url : (_b = item === null || item === void 0 ? void 0 : item.image) === null || _b === void 0 ? void 0 : _b.url;
    if (!video) {
        // negalima grazint funkcinio komponento, butinai jsx
        // nes crop neveiks
        return (React.createElement("img", Object.assign({ className: `ltg-gallery-current-img${cropped ? ' --cropped' : ''}`, src: src || placeholder, alt: (item === null || item === void 0 ? void 0 : item.alt) || ((_c = item === null || item === void 0 ? void 0 : item.image) === null || _c === void 0 ? void 0 : _c.alt) || __("Pagrindinė galerijos nuotrauka", "ltg-widgets") }, fitPostStyle)));
    }
    return React.createElement(Video, null);
    function Video() {
        const [playing, setPlaying] = useState(false);
        const [player, setPlayer] = useState(null);
        useEffect(() => {
            if (!player)
                return;
            if (playing) {
                player.play();
            }
        }, [player, playing]);
        if (embedSources.includes(item.video_source)) {
            return React.createElement(VideoEmbed, { url: video, source: item.video_source });
        }
        return (React.createElement(React.Fragment, null,
            !playing && React.createElement(Image, { onClick: () => { setPlaying(true); } }),
            playing && React.createElement("video", { controls: true, ref: setPlayer, className: "ltg-gallery-current-video", src: video })));
    }
    function Image({ onClick }) {
        var _a;
        return (React.createElement("img", Object.assign({ className: `ltg-gallery-current-img${cropped ? ' --cropped' : ''}`, src: src, alt: (item === null || item === void 0 ? void 0 : item.alt) || ((_a = item === null || item === void 0 ? void 0 : item.image) === null || _a === void 0 ? void 0 : _a.alt) || __("Pagrindinė galerijos nuotrauka", "ltg-widgets") }, fitPostStyle, { onClick: onClick })));
    }
}
function Arrow({ command, dir }) {
    const onKeyDown = (ev) => {
        if (!pressed(ev))
            return;
        ev.preventDefault();
        ev.stopPropagation();
        command(dir);
    };
    const { __ } = useI18n();
    return (React.createElement("span", { role: "button", className: `ltg-gallery-btn ltg-gallery-${dir === -1 ? 'prev' : 'next'}`, tabIndex: 0, onClick: () => { command(dir); }, onKeyDown: onKeyDown },
        React.createElement("i", { className: `fas fa-chevron-${dir === -1 ? 'left' : 'right'}` }),
        React.createElement("span", { className: "sr-only" }, dir === -1 ? __('Atgal', "ltg-widgets") : __('Pirmyn', "ltg-widgets"))));
}
function pressed(ev) {
    return ['ENTER', ' '].includes(ev.key.toUpperCase());
}
